export default {
  required: [
    v => !!v || 'Field is required',
  ],
  codeRules: [
    v => v.length == 5 || 'Invalid code length',
    v => /^[0-9a-zA-Z]*$/.test(v) || 'Code must be alphanumeric',
  ],
  nameRules: [
    v => (v.length > 1 || v.length == 0) || 'Field is too short',
    v => v.length < 64 || 'Field is too long',
    v => /^[0-9a-zA-Z ]*$/.test(v) || 'Field must be alphanumeric',
  ],
  addressRules: [
    v => (v.length > 1 || v.length == 0) || 'Field is too short',
    v => v.length < 256|| 'Field is too long',
    v => /^[0-9a-zA-Z .#,]*$/.test(v) || 'Field must be alphanumeric',
  ],
  phoneRules: [
    v => (/^[2-9]\d{2}-\d{3}-\d{4}$/.test(v) || /^[2-9]\d{2}\d{3}\d{4}$/.test(v)) || 'Invalid phone number',
  ],
  zipRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length == 5 || v.length == 0) || 'Zip must be 5 numbers',
  ],
  routingNumberRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length == 9 || v.length == 0) || 'Routing number must be 9 numbers',
  ],
  accountNumberRules: [
    v => /^[0-9]*$/.test(v) || 'Must contain only numbers',
    v => (v.length >= 9 && v.length <= 12 || v.length == 0) || 'Account number must be 9–12 numbers',
  ],
  emailRules: [
    v => v.length <= 320 || 'Email is too long',
    v => /\S+@\S+\.\S+/.test(v) || 'E-mail must be valid',
  ],
  states: [
   'AL','AK','AS','AZ','AR','CA','CO','CT','DE','DC','FM','FL','GA',
   'GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MH','MD','MA',
   'MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
   'MP','OH','OK','OR','PW','PA','PR','RI','SC','SD','TN','TX','UT',
   'VT','VI','VA','WA','WV','WI','WY'
  ],
  optionalNumbersRule: [
    v => ( v.length == 0 || /^[0-9]*$/.test(v) ) || 'Must contain only numbers'
  ],
  optionalDate: [
    v => ( v.length == 0 || (v.split("/")[0].length >= 1 && v.split("/")[0].length <= 2 && v.split("/")[1].length >= 1 && v.split("/")[1].length <= 2 && v.split("/")[2].split(" ")[0].length >= 2) ) || 'Ensure Date format is MM/DD/YYYY HH:MM:SS'
  ]
}
